import { fetchBaseQuery } from '@reduxjs/toolkit/dist/query'

export const baseQuery = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_BASE_URL,
  prepareHeaders: (headers) => {
    const token = localStorage.getItem('accessToken')

    if (token) {
      headers.set('Authorization', `Bearer ${token}`)
    }
    return headers
  },
})

// Note: Token refresh is handled by the axios interceptor in axiosClient.js
// RTK Query uses this baseQuery for fetch-based requests
// For 401 errors, the axios interceptor will handle token refresh automatically
export const baseQueryWithReauth = baseQuery
